import { createContext, use } from 'react'

export interface SimpleUser {
  firstNames: string
  lastName: string
}

export interface UserContext {
  user?: SimpleUser
  secondaryUser?: SimpleUser
}

export const UserContext = createContext<UserContext>({} as UserContext)

export const useUserContext = (): UserContext => {
  return use(UserContext)
}

export const getDisplayName = (
  user: SimpleUser | undefined,
  isDesktopSize: boolean,
  isLargeDesktopSize: boolean,
): string | undefined => {
  if (!user) {
    return undefined
  }

  const { firstNames, lastName } = user
  if (!isDesktopSize) {
    return undefined
  }
  if (isLargeDesktopSize) {
    return `${firstNames} ${lastName}`
  }
  return `${firstNames} ${lastName.charAt(0)}.`
}
